import { ReactNode, useState } from "react";

import { ExpandableSection } from "@/Common/Components/ExpandableSection";
import { OnClickAction, TriStateCheckboxControl } from "@/Common/Components/Inputs/TriStateCheckboxControl";

import styles from "./PermissionSettingsSectionComponent.module.scss";

interface CollapsibleTriStateCheckboxesComponentProps {
    label: string;
    id?: string;
    children?: ReactNode;
    disabled?: boolean;
    onParentClick: (action: OnClickAction) => void ;
    childrenState: boolean[];
    dataCy?: string;
}

function CollapsibleTriStateCheckboxesComponent(props: CollapsibleTriStateCheckboxesComponentProps): JSX.Element {
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

    const title = (
        <div className={styles.parentCheckbox} data-cy={props.dataCy}>
            <TriStateCheckboxControl
                id={props.id}
                checkedStates={props.childrenState}
                disabled={props.disabled}
                onClick={action => props.onParentClick(action)}
                label={<h4>{props.label}</h4>}
            />
        </div>
    );

    return (
        <ExpandableSection
            title={title}
            onChevronClick={() => setIsCollapsed(!isCollapsed)}
            isOpen={isCollapsed}
            showChevronIcon={!!props.children}
            children={props.children}
        />
    );
}

export { CollapsibleTriStateCheckboxesComponent };
